export const homeObjOne = {
  imgStart: false,
  headLine: "Enjoy on your TV.",
  descText:
    "Watch on Smart TVs, Playstation, Xbox, Chromecast, Apple TV, Blu-ray players, and more.",
  img: "tv.png",
};

export const homeObjTwo = {
  imgStart: true,
  headLine: "Download your shows to watch offline. ",
  descText: "Save your favorites easily and always have something to watch.",
  img: "netflix-2.jpg",
};

export const homeObjThree = {
  imgStart: false,
  headLine: "Watch everywhere. ",
  descText:
    "Stream unlimited movies and TV shows on your phone, tablet, laptop, and TV.",
  img: "",
};

export const homeObjFour = {
  imgStart: true,
  headLine: "Create profiles for kids.",
  descText:
    "Send kids on adventures with their favorite characters in a space made just for them—free with your membership.",
  img: "img-3.png",
};
